import { client } from "./_base";

export const pucs = client("producerpuc", (item) => ({
  ...item,
}));
